import {
  faLongArrowDown,
  faLongArrowUp,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function Sort({ sortAscending, onSort }) {
  return (
    <button
      onClick={onSort}
      className="text-sm h-6 text-indigo-500 border-indigo-500 hover:bg-indigo-200 dark:hover:bg-gray-800 rounded-full px-2 border whitespace-nowrap"
      data-testid="date-sort-button"
    >
      {!sortAscending ? "Oldest " : "Newest "}
      <FontAwesomeIcon
        icon={!sortAscending ? faLongArrowDown : faLongArrowUp}
      />
    </button>
  );
}
